"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyLogger = exports.EMPTY_LOGGER = void 0;
const named_1 = require("./named");
exports.EMPTY_LOGGER = {
    log: named_1.EMPTY_FUNCTION,
    warn: named_1.EMPTY_FUNCTION,
    error: named_1.EMPTY_FUNCTION,
};
class ProxyLogger extends named_1.NamedLogger {
    get implementation() { return this._logger || exports.EMPTY_LOGGER; }
    constructor(logger, name) {
        super(name);
        this._logger = null;
        this.setLogger(logger);
    }
    setLogger(logger) {
        this._logger = logger || null;
        if (this._logger) {
            this.enable();
        }
        else {
            this.disable();
        }
    }
}
exports.ProxyLogger = ProxyLogger;
//# sourceMappingURL=proxy.js.map